/* eslint-disable linebreak-style */

export const ApiStart = 'https://labyrinth.technigo.io/start'
export const ApiMove = 'https://labyrinth.technigo.io/action'